import { Injectable } from '@angular/core';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';

// Thin wrapper around @aparajita/capacitor-secure-storage — Android Keystore-backed on
// native, falls back to the plugin's own web implementation in the browser, so the same
// call site works for both the Capacitor app and the plain web PWA build.
@Injectable({ providedIn: 'root' })
export class SecureKeyService {
  async getItem(key: string): Promise<string | null> {
    try {
      return await SecureStorage.getItem(key);
    } catch {
      return null;
    }
  }

  async setItem(key: string, value: string): Promise<void> {
    await SecureStorage.setItem(key, value);
  }

  async removeItem(key: string): Promise<void> {
    try {
      await SecureStorage.removeItem(key);
    } catch {
      // no-op — nothing to remove
    }
  }
}
